"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const attribute_value_item_checkmark_styles_1 = require("./attribute-value-item-checkmark.styles");
const localization_1 = require("../../../localization");
const AttributeValueItemCheckmark = ({ isStrategized, onStrategize }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const onStrategizeClick = (event) => {
        event.stopPropagation();
        onStrategize === null || onStrategize === void 0 ? void 0 : onStrategize();
    };
    const shouldShowTooltip = !isStrategized;
    return (react_1.default.createElement(ui_components_1.ToolTip, { arrow: true, title: shouldShowTooltip ? t({ key: 'ADD_SUGGESTED_VALUE' }) : null, placement: "top" }, react_1.default.createElement(attribute_value_item_checkmark_styles_1.StyledCheckmarkWrapper, { "$isStrategized": isStrategized }, isStrategized
        ? react_1.default.createElement(ui_components_1.Icon, { variant: 'check' })
        : react_1.default.createElement(attribute_value_item_checkmark_styles_1.StyledAddIcon, { onClick: onStrategizeClick, variant: "addRounded", color: ui_components_1.baseColors.primaryGreen300 }))));
};
exports.default = AttributeValueItemCheckmark;
